<template>
  <div>
    <transition name="splash">
      <SplashScreen v-if="loading" />
    </transition>
    <div v-if="!loading">
      <!-- Admin panel has its own layout (sidebar + top bar) -->
      <router-view v-if="isAdmin" />
      <div v-else class="min-h-screen bg-gray-100 flex flex-col overflow-clip">
      <!-- 3D doodle rings, fixed behind all page content -->
      <DecorBackground />
      <NavBar @open-modal="handleOpenModal" />
      <div class="relative z-10 flex-1">
        <router-view />
      </div>
      <FooTer class="relative z-10" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import NavBar from './components/NavBar.vue'
import SplashScreen from './components/SplashScreen.vue'
import FooTer from './components/FooterBar.vue'
import DecorBackground from './components/DecorBackground.vue'

const route = useRoute()
const isAdmin = computed(() => route.path.startsWith('/admin'))

// No splash screen when opening the admin panel directly
const loading = ref(!window.location.pathname.startsWith('/admin'))

onMounted(() => {
  if (!loading.value) return
  setTimeout(() => {
    loading.value = false
  }, 1500) // Show splash screen for 1.5 seconds
})

function handleOpenModal() {
  // optional: handle modal open logic if needed
}
</script>

<style>
/* Splash exits by sliding up like a curtain */
.splash-leave-active {
  transition: transform 0.75s cubic-bezier(0.76, 0, 0.24, 1);
}
.splash-leave-to {
  transform: translateY(-100%);
}
@media (prefers-reduced-motion: reduce) {
  .splash-leave-active {
    transition: opacity 0.3s ease;
  }
  .splash-leave-to {
    transform: none;
    opacity: 0;
  }
}
</style>
